export const DEFAULT_STALE_TIME = 300_000; // 5 minutes
